export const dealStatus = [
  { id: 'f1050d97-704e-430c-8e4a-4281f5507d27', text: 'Sem contato' },
  { id: 'da514b78-e5ad-4d83-ac97-cea29a5fadf4', text: 'Contato feito' },
  { id: 'de79f869-754b-49de-a6c9-ed21aa8f64f9', text: 'Identificação do interesse' },
  { id: '8b29bd7e-3e11-4e42-ab43-057958a519df', text: 'Apresentação' },
  { id: '2b486647-03e2-4396-a3d2-ce1d33487dd2', text: 'Proposta Enviada' },
  { id: 'de80a623-0201-448b-b51a-159b4ba3e607', text: 'Declinar' },
]